import { atom, selector, selectorFamily } from 'recoil'
import { MESSAGE_BOX_VARIANT_WARNING } from 'mailup-web-components'
import {
  PECPLUS_STATUS_ERROR_DESCR,
  PECPLUS_STATUS_IN_PROGRESS_DESCR,
  STORE_KEY_ID_LIST
}
  from 'Constants/'

import { storeGet } from 'Helpers/localStorage'

export const pageState = atom({
  key: 'scheduledSendingsPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: MESSAGE_BOX_VARIANT_WARNING,
    title: undefined,
    allLists: []
  }
})

export const modalListFilterState = atom({
  key: 'scheduledSendingsModalListFilterState',
  default: {
    show: false,
    value: []
  }
})

export const pecPlusConfigState = atom({
  key: 'scheduledSendingsStatusPecPlusConfigState',
  default: []
})

export const pecPlusStatusState = selector({
  key: 'scheduledSendingsPecPlusStatusState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    const idList = storeGet(STORE_KEY_ID_LIST)

    const config = configs.find(c => c.IdList === idList)
    return config?.Status
    //  $scope.setScheduleConfig
  }
})

export const pecPlusListStatusState = selectorFamily({
  key: 'scheduledSendingsPecPlusListStatusState',
  get: idList => ({ get }) => {
    const configs = get(pecPlusConfigState)

    const config = configs.find(c => c.IdList === idList)
    return config?.Status
  }
})

export const pecPlusErrorState = selector({
  key: 'scheduledSendingsPecPlusErrorState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    return configs.filter(c => c.Status === PECPLUS_STATUS_ERROR_DESCR)
    //  return configs
  }
})

export const pecPlusInProgressState = selector({
  key: 'scheduledSendingsPecPlusInProgressState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    return configs.filter(c => c.Status === PECPLUS_STATUS_IN_PROGRESS_DESCR)
  }
})
